export const UPDATE_ACCOUNT_BALANCE = 'UPDATE_ACCOUNT_BALANCE';

function accountBalanceReducer (state = {}, action) {
  switch (action.type) {
    case UPDATE_ACCOUNT_BALANCE:
      let newState = {...state};
      newState[action.payload.address] = state[action.payload.address] || {
        address: action.payload.address,
        balance: 0
      };
      newState[action.payload.address].balance += action.payload.balanceChange;

      return newState;
    default:
      return state;
  }
}

export default accountBalanceReducer;




// WEBPACK FOOTER //
// ./src/storage/AccountBalanceReducer.js